import React from 'react';
import { map } from 'lodash';
import { capitalCase } from 'change-case';
import clsx from 'clsx';
import { API_KEY_STATUS_DELETE_FAILED, API_KEY_STATUS_EXPIRED, API_KEY_STATUS_PENDING_REGISTRATION } from '../../../constants';
import {
  KEY_STATUS_ENABLED,
} from './labels';

const MAX_LENGTH = 5000;
export const isApplicationDirty = (base, modified) => {
 return !base ||
  base.name !== modified.name ||
  ((base.description || modified.description) && base.description !== modified.description);
}

export const checkCustomFieldsDirty = (base, modified) =>
  Object.keys(modified)
    .some(key => (modified[key].trim() || base[key]) && modified[key].trim() !== base[key]);

export const validateAppDetails = (appDetailsObject) =>
  appDetailsObject.name &&
  appDetailsObject.name.length > 0 &&
  appDetailsObject.name.length < 51;

export const validateCustomFields = (customFields, customFieldValues) =>
  customFields &&
  customFields.length>0 &&
  customFields.every(customField =>
    (!customField.required ||
      (customFieldValues[customField.uuid] &&
       customFieldValues[customField.uuid].length >0)
      ) && (!customFieldValues[customField.uuid] ||
        customFieldValues[customField.uuid].length <= MAX_LENGTH));

export const isAPisFormDirty = (apisArray, baseApisArray) =>
  apisArray.length !== baseApisArray ||
  apisArray.some(api => !baseApisArray.includes(api));

export const processErrors = (arrErrors, defaultMessage) => {
  let errorMessage = defaultMessage;
  if (arrErrors.length > 0) {
    errorMessage = map(arrErrors, (validationError) => validationError.error).join('\n');
  }
  return errorMessage;
};

export const getKeyStatus = (status, classes) => {
  let className = classes.enabled;
  if (status === API_KEY_STATUS_DELETE_FAILED) {
    className = classes.deleteFailed;
  } else if (status === KEY_STATUS_ENABLED) {
    className = classes.enabled;
  } else if (status === API_KEY_STATUS_EXPIRED) {
    className = classes.deleteFailed;
  } else if (status === API_KEY_STATUS_PENDING_REGISTRATION) {
    className = classes.pendingRegistrationKey;
  } else {
    className = classes.disabled;
  }
  return (<span className={clsx(classes.status, className)}>
    {capitalCase(status)}
  </span>);
};
